import { workflowActionTypes } from '@Actions/workflowActions';

const WorkflowsReducers = (state = {}, action) => {
  switch (action.type) {
    // Purchase
    case workflowActionTypes.GET_PURCHASE_WORKFLOWS.LOADING: {
      const { getPurchaseWorkflowsLoading } = action;
      return {
        ...state,
        getPurchaseWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_PURCHASE_WORKFLOWS.SUCCESS: {
      const { purchaseWorkflows } = action;
      return {
        ...state,
        purchaseWorkflows,
      };
    }
    case workflowActionTypes.GET_PURCHASE_WORKFLOW_SAMPLE.LOADING: {
      const { getPurchaseWorkflowSampleLoading } = action;
      return {
        ...state,
        getPurchaseWorkflowSampleLoading,
      };
    }
    case workflowActionTypes.GET_VENDOR_WORKFLOWS.LOADING: {
      const { getVendorWorkflowsLoading } = action;
      return {
        ...state,
        getVendorWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_VENDOR_WORKFLOWS.SUCCESS: {
      const { vendorWorkflows } = action;
      return {
        ...state,
        vendorWorkflows,
      };
    }
    // Sales Estimate
    case workflowActionTypes.GET_SALES_ESTIMATE_WORKFLOWS.LOADING: {
      const { getSalesEstimateWorkflowsLoading } = action;
      return {
        ...state,
        getSalesEstimateWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_SALES_ESTIMATE_WORKFLOWS.SUCCESS: {
      const { salesEstimateWorkflows } = action;
      return {
        ...state,
        salesEstimateWorkflows,
      };
    }
    // Sales Order
    case workflowActionTypes.GET_SALES_ORDER_WORKFLOWS.LOADING: {
      const { getSalesOrderWorkflowsLoading } = action;
      return {
        ...state,
        getSalesOrderWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_SALES_ORDER_WORKFLOWS.SUCCESS: {
      const { salesOrderWorkflows } = action;
      return {
        ...state,
        salesOrderWorkflows,
      };
    }
    // Packing Slip
    case workflowActionTypes.GET_PACKING_SLIP_WORKFLOWS.LOADING: {
      const { getPackingSlipWorkflowsLoading } = action;
      return {
        ...state,
        getPackingSlipWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_PACKING_SLIP_WORKFLOWS.SUCCESS: {
      const { PackingSlipWorkflows } = action;
      return {
        ...state,
        PackingSlipWorkflows,
      };
    }
    // Invoice
    case workflowActionTypes.GET_INVOICE_WORKFLOWS.LOADING: {
      const { getInvoiceWorkflowsLoading } = action;
      return {
        ...state,
        getInvoiceWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_INVOICE_WORKFLOWS.SUCCESS: {
      const { invoiceWorkflows } = action;
      return {
        ...state,
        invoiceWorkflows,
      };
    }
    // Credit Note
    case workflowActionTypes.GET_CREDIT_NOTE_WORKFLOWS.LOADING: {
      const { getCreditNoteWorkflowsLoading } = action;
      return {
        ...state,
        getCreditNoteWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_CREDIT_NOTE_WORKFLOWS.SUCCESS: {
      const { creditNoteWorkflows } = action;
      return {
        ...state,
        creditNoteWorkflows,
      };
    }
    // Debit Note
    case workflowActionTypes.GET_DEBIT_NOTE_WORKFLOWS.LOADING: {
      const { getDebitNoteWorkflowsLoading } = action;
      return {
        ...state,
        getDebitNoteWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_DEBIT_NOTE_WORKFLOWS.SUCCESS: {
      const { debitNoteWorkflows } = action;
      return {
        ...state,
        debitNoteWorkflows,
      };
    }
    // Purchase Request
    case workflowActionTypes.GET_PURCHASE_REQUEST_WORKFLOWS.LOADING: {
      const { getPurchaseRequestWorkflowsLoading } = action;
      return {
        ...state,
        getPurchaseRequestWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_PURCHASE_REQUEST_WORKFLOWS.SUCCESS: {
      const { purchaseRequestWorkflows } = action;
      return {
        ...state,
        purchaseRequestWorkflows,
      };
    }
    // Stock Adjustment
    case workflowActionTypes.GET_STOCK_ADJUSTMENT_WORKFLOWS.LOADING: {
      const { getStockAdjustmentWorkflowsLoading } = action;
      return {
        ...state,
        getStockAdjustmentWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_STOCK_ADJUSTMENT_WORKFLOWS.SUCCESS: {
      const { StockAdjustmentWorkflows } = action;
      return {
        ...state,
        StockAdjustmentWorkflows,
      };
    }

    // Stock Transfer
    case workflowActionTypes.GET_STOCK_TRANSFER_WORKFLOWS.LOADING: {
      const { getStockTransferWorkflowsLoading } = action;
      return {
        ...state,
        getStockTransferWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_STOCK_TRANSFER_WORKFLOWS.SUCCESS: {
      const { StockTransferWorkflowsSuccess } = action;
      return {
        ...state,
        StockTransferWorkflowsSuccess,
      };
    }
    // Goods Receiving
    case workflowActionTypes.GET_GOODS_RECEIVING_WORKFLOWS.LOADING: {
      const { getGoodsReceivingWorkflowsLoading } = action;
      return {
        ...state,
        getGoodsReceivingWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_GOODS_RECEIVING_WORKFLOWS.SUCCESS: {
      const { StockTransferWorkflows } = action;
      return {
        ...state,
        StockTransferWorkflows,
      };
    }

    case workflowActionTypes.CREATE_WORKFLOWS.LOADING: {
      const { createWorkflowsLoading } = action;
      return {
        ...state,
        createWorkflowsLoading,
      };
    }
    case workflowActionTypes.CREATE_WORKFLOW_V2.LOADING: {
      const { createWorkflowV2Loading } = action;
      return {
        ...state,
        createWorkflowV2Loading,
      };
    }

    // Delivery Challan
    case workflowActionTypes.GET_DELIVERY_CHALLAN_WORKFLOWS.LOADING: {
      const { getDeliveryChallanWorkflowsLoading } = action;
      return {
        ...state,
        getDeliveryChallanWorkflowsLoading,
      };
    }
    case workflowActionTypes.GET_DELIVERY_CHALLAN_WORKFLOWS.SUCCESS: {
      const { deliveryChallanWorkflows } = action;
      return {
        ...state,
        deliveryChallanWorkflows,
      };
    }

    // add additional workflow approvals
    case workflowActionTypes.ADD_ADDITIONAL_WORKFLOW_APPROVALS.LOADING: {
      const { addAdditionalWorkflowApprovalsLoading } = action;
      return {
        ...state,
        addAdditionalWorkflowApprovalsLoading,
      };
    }

    default: {
      return state;
    }
  }
};

export default WorkflowsReducers;
